const STRAPI_STALE_TIME = 3000;

const API_BASE_URL = process.env.REACT_APP_USHG_API_BASE_URL;

const USERS_API_PATH = {
  SUBMIT_HUBSPOT_FORM: `/users/public/v1/hubspot`,
};

export { STRAPI_STALE_TIME, USERS_API_PATH, API_BASE_URL };
